<template>
  <div class="intro">
    <h3 class="intro__title">
       10,000+ of our users love our products.
    </h3>
    <h3 class="intro__text">
        We only provide great products combined with excellent customer service.
        See what our satisfied customers are saying about our services.
    </h3>
    </div>
</template>

<script>
export default {
  name: 'Intro',
};
</script>

<style lang="scss" scoped>
  .intro {
    color: var(--very-dark-magenta);

    &__title {
      max-width: 11ch;
      font-size: var(--fs-h1);
      line-height: 1;
      margin-bottom: var(--sm-spacer);
    }

    &__text {
      font-weight: normal;
      color: var(--dark-grayish-magenta);
    }

    @media (min-width: 50em) {
      text-align: initial;
    }
  }
</style>
